export default "__VITE_ASSET__Cs85l9q3__"